module.exports = __webpack_public_path__ + "static/img/kb-card-img-03-02@t.04bd9b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/kb-card/kb-card-img-03-02@t.jpg
// module id = 8jXz
// module chunks = 0